import React from 'react';
import axios from 'axios';
import parseHtmlToReact from 'html-react-parser';
import PropTypes from 'prop-types';

import { Link } from '..';
import Popup from './Popup';

/**
 * Page wrapper that provides context passed in as 'data', and renders the view
 */
export default class AsyncPopupTextLink extends React.PureComponent {
  state = {
    isPopupOpen: false,
    popupContent: undefined,
  };

  requestPopupContent = () => {
    const { contentRequestUrl } = this.props;
    const { popupContent } = this.state;

    if (typeof popupContent === 'undefined') {
      this.setState({ popupContent: null });
      axios.get(contentRequestUrl).then(({ data }) => {
        if (typeof data === 'string') {
          this.setState({ popupContent: parseHtmlToReact(data) });
        }
      });
    }
  };

  isolateEvent = (event) => event.preventDefault();

  handleMouseOver = () => this.requestPopupContent();

  openPopup = () => {
    this.setState({ isPopupOpen: true });
  };

  closePopup = () => this.setState({ isPopupOpen: false });

  render() {
    const { children, className } = this.props;
    const { isPopupOpen, popupContent } = this.state;

    return (
      <span
        className={className}
        onClick={this.isolateEvent}
        onMouseOver={this.handleMouseOver}
        role="presentation"
      >
        <Link onClick={this.openPopup}>{children}</Link>
        <Popup isOpen={isPopupOpen} onClose={this.closePopup}>
          {popupContent}
        </Popup>
      </span>
    );
  }
}

AsyncPopupTextLink.propTypes = {
  children: PropTypes.node,
  className: PropTypes.node,
  contentRequestUrl: PropTypes.string,
};
